import apiClient from './client';

export interface Contact {
  id: number;
  account_id?: number;
  first_name: string;
  last_name: string;
  email?: string;
  phone?: string;
  title?: string;
  created_at: string;
  updated_at: string;
}

export interface ContactsResponse {
  success: boolean;
  data: Contact[];
}

export const contactsApi = {
  getAll: async (): Promise<Contact[]> => {
    const response = await apiClient.get<ContactsResponse>('/contacts');
    return response.data.data;
  },
  getById: async (id: number): Promise<Contact> => {
    const response = await apiClient.get<{ success: boolean; data: Contact }>(`/contacts/${id}`);
    return response.data.data;
  },
  create: async (contact: Partial<Contact>): Promise<Contact> => {
    const response = await apiClient.post<{ success: boolean; data: Contact }>('/contacts', contact);
    return response.data.data;
  },
  update: async (id: number, contact: Partial<Contact>): Promise<Contact> => {
    const response = await apiClient.patch<{ success: boolean; data: Contact }>(`/contacts/${id}`, contact);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/contacts/${id}`);
  },
};

